import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';
import { ButtonItem, HeadingItem, MenuGroup, Section } from '@atlaskit/menu';
import { inject } from 'mobx-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { LINK_URLS } from '../../../../constants/links';
import { withAnalytics } from '../../../../hoc/withAnalytics';
import Store from '../../../../store';
import UserStore from '../../../../store/userStore';
import { logout } from '../../../../util/auth';
import { profileMessages as messages } from '../../../common/intl/profile';
import TrackedLinkItem from '../../../common/TrackedLinkItem';

interface InjectedStoreProps {
  userStore: UserStore;
}

type Props = InjectedStoreProps;

const ProfileMenuContent = inject<InjectedStoreProps>(({ userStore }: Store) => ({
  userStore,
}))(
  withAnalytics<Props>(({ userStore, analytics }) => {
    const name = userStore.name || '';
    return (
      <MenuGroup minWidth="300px">
        <Section>
          <HeadingItem>{name}</HeadingItem>
          <TrackedLinkItem
            description={<FormattedMessage {...messages.manageYourAccount} />}
            iconAfter={<ShortcutIcon label="" />}
            href={LINK_URLS.MANAGE_PROFILE}
            actionSubject="menuItem"
            action="clicked"
            extraAnalyticProps={{
              item: 'manageProfile',
            }}
            openInNewTab
            testId="nav__manage-profile-btn"
            synchroniseSession={true}
          >
            <FormattedMessage {...messages.accountSettings} />
          </TrackedLinkItem>
        </Section>
        <Section hasSeparator>
          <ButtonItem
            testId="nav__logout-btn"
            onClick={async e => {
              e.preventDefault();
              await analytics.ui('logoutButton', 'clicked');
              logout();
            }}
          >
            <FormattedMessage {...messages.logout} />
          </ButtonItem>
        </Section>
      </MenuGroup>
    );
  }),
);

export default ProfileMenuContent;
